import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  title: 'Faites votre liste des 23',
  currentSection: 0,
  sections: []
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/sections/index.js